import * as XLSX from 'xlsx';
import { supabase } from '../lib/supabase';
import toast from 'react-hot-toast';
import { format } from 'date-fns';

export const exportEquipamentosToExcel = async () => {
  try {
    const { data, error } = await supabase
      .from('ti_solicitacoes')
      .select('*')
      .order('created_at', { ascending: false });

    if (error) throw error;

    if (!data || data.length === 0) {
      toast.error('Não há solicitações para exportar');
      return;
    }

    const priorityLabels: Record<string, string> = {
      low: 'Baixa',
      medium: 'Média',
      high: 'Alta',
    };

    const statusLabels: Record<string, string> = {
      pending: 'Pendente',
      approved: 'Aprovado',
      delivered: 'Entregue',
    };

    const excelData = data.map((req: any) => ({
      'Equipamento': req.equipamento,
      'Solicitante': req.solicitante_nome,
      'Email': req.solicitante_email || '',
      'Justificativa': req.descricao,
      'Prioridade': priorityLabels[req.prioridade] || req.prioridade,
      'Status': statusLabels[req.status] || req.status,
      'Data da Solicitação': new Date(req.created_at).toLocaleDateString('pt-BR'),
    }));

    const worksheet = XLSX.utils.json_to_sheet(excelData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Solicitações');
    worksheet['!cols'] = [{ wch: 25 }, { wch: 25 }, { wch: 30 }, { wch: 40 }, { wch: 12 }, { wch: 12 }, { wch: 15 }];

    const fileName = `solicitacoes-equipamentos-${new Date().toISOString().split('T')[0]}.xlsx`;
    XLSX.writeFile(workbook, fileName);
    toast.success('Planilha exportada com sucesso!');
  } catch (error: any) {
    console.error('[EXPORT] Error:', error);
    toast.error('Erro ao exportar: ' + (error.message || 'Tente novamente'));
  }
};

export const exportReservasSalasToExcel = async () => {
  try {
    const { data, error } = await supabase
      .from('reservas_salas')
      .select('*, usuarios(nome)')
      .order('data_reserva', { ascending: false });

    if (error) throw error;

    if (!data || data.length === 0) {
      toast.error('Não há reservas para exportar');
      return;
    }

    const excelData = data.map((r: any) => ({
      'Sala': r.sala,
      'Motivo': r.motivo,
      'Solicitante': r.usuarios?.nome || 'N/A',
      'Data': new Date(r.data_reserva).toLocaleDateString('pt-BR'),
      'Hora Início': r.hora_inicio,
      'Hora Fim': r.hora_fim,
      'Observações': r.observacoes || '',
    }));

    const worksheet = XLSX.utils.json_to_sheet(excelData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Reservas');
    worksheet['!cols'] = [{ wch: 20 }, { wch: 30 }, { wch: 25 }, { wch: 12 }, { wch: 12 }, { wch: 12 }, { wch: 40 }];

    XLSX.writeFile(workbook, `reservas-salas-${new Date().toISOString().split('T')[0]}.xlsx`);
    toast.success('Planilha exportada com sucesso!');
  } catch (error: any) {
    console.error('[EXPORT] Error:', error);
    toast.error('Erro ao exportar: ' + (error.message || 'Tente novamente'));
  }
};

export const exportAgendamentosPortariaToExcel = async () => {
  try {
    const { data, error } = await supabase
      .from('portaria_agendamentos')
      .select('*, usuarios(nome)')
      .order('data', { ascending: false });

    if (error) throw error;

    if (!data || data.length === 0) {
      toast.error('Não há agendamentos para exportar');
      return;
    }

    const excelData = data.map((ag: any) => ({
      'Visitante': ag.visitante,
      'Documento': ag.documento || 'N/A',
      'Data': new Date(ag.data).toLocaleDateString('pt-BR'),
      'Hora': ag.hora,
      'Status': ag.status === 'pending' ? 'Pendente' : ag.status === 'approved' ? 'Aprovado' : 'Concluído',
      'Solicitante': ag.usuarios?.nome || 'N/A',
      'Observações': ag.observacao || '',
    }));

    const worksheet = XLSX.utils.json_to_sheet(excelData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Agendamentos');
    worksheet['!cols'] = [{ wch: 25 }, { wch: 20 }, { wch: 12 }, { wch: 10 }, { wch: 12 }, { wch: 25 }, { wch: 40 }];

    XLSX.writeFile(workbook, `agendamentos-portaria-${new Date().toISOString().split('T')[0]}.xlsx`);
    toast.success('Planilha exportada com sucesso!');
  } catch (error: any) {
    console.error('[EXPORT] Error:', error);
    toast.error('Erro ao exportar: ' + (error.message || 'Tente novamente'));
  }
};

export const exportReservasVeiculosToExcel = async () => {
  try {
    const { data, error } = await supabase
      .from('reserva_veiculos')
      .select('*')
      .order('data_retirada', { ascending: false });

    if (error) throw error;

    if (!data || data.length === 0) {
      toast.error('Não há reservas de veículos para exportar');
      return;
    }

    const excelData = data.map((rv: any) => ({
      'Solicitante': rv.nome,
      'Veículo': rv.veiculo,
      'Empresa': rv.empresa,
      'Motivo': rv.motivo,
      'Data Retirada': new Date(rv.data_retirada).toLocaleDateString('pt-BR'),
      'Hora Retirada': rv.horario_retirada,
      'Data Entrega': new Date(rv.data_entrega).toLocaleDateString('pt-BR'),
      'Hora Entrega': rv.horario_entrega,
    }));

    const worksheet = XLSX.utils.json_to_sheet(excelData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Veículos');
    worksheet['!cols'] = [{ wch: 25 }, { wch: 15 }, { wch: 15 }, { wch: 30 }, { wch: 12 }, { wch: 12 }, { wch: 12 }, { wch: 12 }];

    XLSX.writeFile(workbook, `reservas-veiculos-${new Date().toISOString().split('T')[0]}.xlsx`);
    toast.success('Planilha exportada com sucesso!');
  } catch (error: any) {
    console.error('[EXPORT] Error:', error);
    toast.error('Erro ao exportar: ' + (error.message || 'Tente novamente'));
  }
};

export const exportTrocasProteinasToExcel = async () => {
  try {
    const { data, error } = await supabase
      .from('trocas_proteina')
      .select('*, usuarios(nome, email)')
      .order('data_troca', { ascending: false })
      .limit(1000);

    if (error) throw error;

    if (!data || data.length === 0) {
      toast.error('Não há trocas para exportar');
      return;
    }

    const excelData = data.map((t: any) => ({
      'Usuário': t.usuarios?.nome || 'N/A',
      'Email': t.usuarios?.email || 'N/A',
      'Data': new Date(t.data_troca).toLocaleDateString('pt-BR'),
      'Proteína Original': t.proteina_original || 'N/A',
      'Proteína Nova': t.proteina_nova || 'N/A',
      'Data da Troca': new Date(t.created_at).toLocaleDateString('pt-BR'),
    }));

    const worksheet = XLSX.utils.json_to_sheet(excelData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Trocas');
    worksheet['!cols'] = [{ wch: 25 }, { wch: 30 }, { wch: 12 }, { wch: 20 }, { wch: 20 }, { wch: 15 }];

    XLSX.writeFile(workbook, `trocas-proteinas-${new Date().toISOString().split('T')[0]}.xlsx`);
    toast.success('Planilha exportada com sucesso!');
  } catch (error: any) {
    console.error('[EXPORT] Error:', error);
    toast.error('Erro ao exportar: ' + (error.message || 'Tente novamente'));
  }
};
